export const Type = {
  ORDER_GET_ALL_ASYNC: "orderGetAllAsync",
  ORDER_GET_ALL_SUCCESS: "orderGetAllSuccess",
  ORDER_GET_ALL_FAILURE: "orderGetAllFailure",
  EXPAND_TOGGLE: "expandToggle",
};
